import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import VerifyPassword from './pages/VerifyPassword';
import PasswordReset from './pages/PasswordReset';
import PasswordResetSuccess from './pages/PasswordResetSuccess';
import Dashboard from './pages/Dashboard';
import Notifications from './pages/Notifications';
import P2pBuyList from './pages/P2pBuyList';
import P2pBuyView from './pages/P2pBuyView';
import P2pSellList from './pages/P2pSellList';
import P2pSellView from './pages/P2pSellView';
import P2pTradeBuyPendingPay from './pages/P2pTradeBuyPendingPay';
import P2pTradeBuyWaitingSeller from './pages/P2pTradeBuyWaitingSeller';
import P2pTradeBuyComplete from './pages/P2pTradeBuyComplete';
import P2pTradeSellWaitingBuyer from './pages/P2pTradeSellWaitingBuyer';
import P2pTradeSellPendingRelease from './pages/P2pTradeSellPendingRelease';
import P2pTradeSellComplete from './pages/P2pTradeSellComplete';
import P2pTradeChat from './pages/P2pTradeChat';
import P2pMerchantDashboard from './pages/P2pMerchantDashboard';
import P2pMerchantSecurityDeposit from './pages/P2pMerchantSecurityDeposit';
import P2pOrders from './pages/P2pOrders';
import P2pDispute from './pages/P2pDispute';
import MyAds from './pages/MyAds';
import MyAdsWithContent from './pages/MyAdsWithContent';
import PostAdStep1 from './pages/PostAdStep1';
import PostAdStep2 from './pages/PostAdStep2';
import PostAdStep3 from './pages/PostAdStep3';
import PostAdSuccess from './pages/PostAdSuccess';
import Swap from './pages/Swap';
import SwapSuccess from './pages/SwapSuccess';
import SwapDetails from './pages/SwapDetails';
import Withdraw from './pages/Withdraw';
import WithdrawalConfirm from './pages/WithdrawalConfirm';
import WithdrawalVerify from './pages/WithdrawalVerify';
import WithdrawalSuccess from './pages/WithdrawalSuccess';
import WithdrawalEmailTransfer from './pages/WithdrawalEmailTransfer';
import WithdrawalVerify2fa from './pages/WithdrawalVerify2fa';
import WithdrawalConfirmWithdrawal from './pages/WithdrawalConfirmWithdrawal';
import Deposit from './pages/Deposit';
import HistoryDeposit from './pages/HistoryDeposit';
import HistoryWithdrawal from './pages/HistoryWithdrawal';
import Profile from './pages/Profile';
import ProfileInfo from './pages/ProfileInfo';
import ProfileSecurity from './pages/ProfileSecurity';
import ProfileFullname from './pages/ProfileFullname';
import ChangePassword from './pages/ChangePassword';
import ProfilePhoneNumber from './pages/ProfilePhoneNumber';
import ProfileManageAccount from './pages/ProfileManageAccount';
import ProfileReferAndEarn from './pages/ProfileReferAndEarn';
import ProfileP2pPaymentMethods from './pages/ProfileP2pPaymentMethods';
import DepositDetails from './pages/DepositDetails';
import Markets from './pages/Markets';
import Assets from './pages/Assets';
import Disable2fa from './pages/Disable2fa';
import Enable2fa from './pages/Enable2fa';
import './App.css';

/**
 * App Component - Main Application Router
 *
 * Provides routing for the Coinsher App Theme design system.
 * - Home page lists all available screens/pages
 * - Individual routes for each screen in mobile viewport
 */
function App() {
  return (
    <Router>
      <Routes>
        {/* Home page - lists all available pages */}
        <Route path="/" element={<Home />} />
        
        {/* Sign In page */}
        <Route 
          path="/login" 
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <SignIn />
                </div>
              </div>
            </div>
          } 
        />
        
        {/* Sign Up page */}
        <Route
          path="/sign-up"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <SignUp />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Forgot Password page */}
        <Route
          path="/forgot-password"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <ForgotPassword />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Verify Password page */}
        <Route
          path="/verify-password"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <VerifyPassword />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Password Reset page */}
        <Route
          path="/password-reset"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <PasswordReset />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Password Reset Success page */}
        <Route
          path="/password-reset-success"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <PasswordResetSuccess />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Dashboard page */}
        <Route
          path="/dashboard"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <Dashboard />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Notifications page */}
        <Route
          path="/notifications"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <Notifications />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Buy List page */}
        <Route
          path="/p2p-buy-list"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pBuyList />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Buy View page */}
        <Route
          path="/p2p-buy-view"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pBuyView />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Sell List page */}
        <Route
          path="/p2p-sell-list"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pSellList />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Sell View page */}
        <Route
          path="/p2p-sell-view"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pSellView />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Trade Buy Pending Pay page */}
        <Route
          path="/p2p-trade-buy-pending-pay"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pTradeBuyPendingPay />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Trade Buy Waiting Seller page */}
        <Route
          path="/p2p-trade-buy-waiting-seller"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pTradeBuyWaitingSeller />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Trade Buy Complete page */}
        <Route
          path="/p2p-trade-buy-complete"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pTradeBuyComplete />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Trade Sell Waiting Buyer page */}
        <Route
          path="/p2p-trade-sell-waiting-buyer"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pTradeSellWaitingBuyer />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Trade Sell Pending Release page */}
        <Route
          path="/p2p-trade-sell-pending-release"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pTradeSellPendingRelease />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Trade Sell Complete page */}
        <Route
          path="/p2p-trade-sell-complete"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pTradeSellComplete />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Trade Chat page */}
        <Route
          path="/p2p-trade-chat"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pTradeChat />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Merchant Dashboard page */}
        <Route
          path="/p2p-merchant-dashboard"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pMerchantDashboard />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Merchant Security Deposit page */}
        <Route
          path="/p2p-merchant-security-deposit"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pMerchantSecurityDeposit />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Orders page */}
        <Route
          path="/p2p-orders"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pOrders />
                </div>
              </div>
            </div>
          }
        />
        
        {/* P2P Dispute page */}
        <Route
          path="/p2p-dispute"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <P2pDispute />
                </div>
              </div>
            </div>
          }
        />
        
        {/* My Ads page */}
        <Route
          path="/my-ads"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <MyAds />
                </div>
              </div>
            </div>
          }
        />

        {/* My Ads With Content page */}
        <Route
          path="/my-ads-with-content"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <MyAdsWithContent />
                </div>
              </div>
            </div>
          }
        />

        {/* Post Ad Step 1 page */}
        <Route
          path="/post-ad-step-1"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <PostAdStep1 />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Post Ad Step 2 page */}
        <Route
          path="/post-ad-step-2"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <PostAdStep2 />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Post Ad Step 3 page */}
        <Route
          path="/post-ad-step-3"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <PostAdStep3 />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Post Ad Success page */}
        <Route
          path="/post-ad-success"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <PostAdSuccess />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Swap page */}
        <Route
          path="/swap"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <Swap />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Swap Success page */}
        <Route
          path="/swap-success"
          element={<SwapSuccess />}
        />
        
        {/* Swap Details page */}
        <Route
          path="/swap-details"
          element={<SwapDetails />}
        />
        
        {/* Withdraw page */}
        <Route
          path="/withdraw"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <Withdraw />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Withdrawal Confirm page */}
        <Route
          path="/withdrawal-confirm"
          element={<WithdrawalConfirm />}
        />
        
        {/* Withdrawal Verify page */}
        <Route
          path="/withdrawal-verify"
          element={<WithdrawalVerify />}
        />
        
        {/* Withdrawal Success page */}
        <Route
          path="/withdrawal-success"
          element={<WithdrawalSuccess />}
        />

        {/* Withdrawal Email Transfer page */}
        <Route
          path="/withdrawal-email-transfer"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <WithdrawalEmailTransfer />
                </div>
              </div>
            </div>
          }
        />

        {/* Withdrawal Verify 2FA page */}
        <Route
          path="/withdrawal-verify-2fa"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <WithdrawalVerify2fa />
                </div>
              </div>
            </div>
          }
        />

        {/* Withdrawal Confirm Withdrawal page */}
        <Route
          path="/withdrawal-confirm-withdrawal"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <WithdrawalConfirmWithdrawal />
                </div>
              </div>
            </div>
          }
        />

        {/* Deposit page */}
        <Route
          path="/deposit"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <Deposit />
                </div>
              </div>
            </div>
          }
        />
        
        {/* History Deposit page */}
        <Route
          path="/history-deposit"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <HistoryDeposit />
                </div>
              </div>
            </div>
          }
        />
        
        {/* History Withdrawal page */}
        <Route
          path="/history-withdrawal"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <HistoryWithdrawal />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Profile page */}
        <Route
          path="/profile"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <Profile />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Profile Info page */}
        <Route
          path="/profile-info"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <ProfileInfo />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Profile Security page */}
        <Route
          path="/profile-security"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <ProfileSecurity />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Profile Fullname page */}
        <Route
          path="/profile-fullname"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <ProfileFullname />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Change Password page */}
        <Route
          path="/change-password"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <ChangePassword />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Profile Phone Number page */}
        <Route
          path="/profile-phone-number"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <ProfilePhoneNumber />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Profile Manage Account page */}
        <Route
          path="/profile-manage-account"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <ProfileManageAccount />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Profile Refer and Earn page */}
        <Route
          path="/profile-refer-and-earn"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <ProfileReferAndEarn />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Profile P2P Payment Methods page */}
        <Route
          path="/profile-p2p-payment-methods"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <ProfileP2pPaymentMethods />
                </div>
              </div>
            </div>
          }
        />
        
        {/* Deposit Details page */}
        <Route
          path="/deposit-details"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <DepositDetails />
                </div>
              </div>
            </div>
          }
        />

        {/* Markets page */}
        <Route
          path="/markets"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <Markets />
                </div>
              </div>
            </div>
          }
        />

        {/* Assets page */}
        <Route
          path="/assets"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <Assets />
                </div>
              </div>
            </div>
          }
        />

        {/* Disable 2FA page */}
        <Route
          path="/disable-2fa"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <Disable2fa />
                </div>
              </div>
            </div>
          }
        />

        {/* Enable 2FA page */}
        <Route
          path="/enable-2fa"
          element={
            <div className="app-container">
              <div className="mobile-frame">
                <div className="mobile-notch"></div>
                <div className="mobile-screen">
                  <Enable2fa />
                </div>
              </div>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
